import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { Field } from 'formik'

import { Dropdown } from '@components/Form/Autocomplete'
import RadioGroup from '@components/Form/RadioGroup'

class DeliverableFormGroup extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    form: PropTypes.object,
    deliverables: PropTypes.object,
    isBackdatingRuleSatisfied: PropTypes.func
  }

  shouldShowUnitsWarning (form) {
    const units = form.values.units
    if (!units) return false
    const employees = form.values.employees
    return employees.reduce(
      (total, e) => (total -= Number(e.units || 0)),
      units
    )
  }

  render () {
    const {
      staticData,
      form,
      deliverables,
      isBackdatingRuleSatisfied
    } = this.props
    const deliverableAttachOptions = [
      {
        value: 'new',
        label: 'Separate deliverable'
      },
      {
        value: 'existing',
        label: 'Existing deliverable'
      }
    ]

    return (
      <div className='expert-form__section'>
        <div className='expert-form__input-group expert-form__input-group__deliverable'>
          <div>
            <Field
              name='deliverableAttach'
              noLabel
              inline
              options={deliverableAttachOptions}
              disabled={!isBackdatingRuleSatisfied(form)}
              component={RadioGroup}
            />
          </div>
          {form.values.deliverableAttach === 'new' ? (
            <Field
              noLabel
              name='deliverableType'
              data-cy='deliverable-type-dropdown'
              placeholder='Deliverable Type'
              options={staticData.deliverableTypes}
              itemToString={item => item && item.name}
              onChange={async item => {
                form.setFieldValue('deliverableType', item && item.id, false)
                form.setFieldTouched('deliverableType', true)

                // NOTE: This is a workaround for
                // https://github.com/jaredpalmer/formik/issues/529
                await Promise.resolve()
              }}
              disabled={!isBackdatingRuleSatisfied(form)}
              component={Dropdown}
            />
          ) : (
            <Field
              noLabel
              name='deliverableId'
              placeholder='Select deliverable'
              options={deliverables}
              itemToString={item => item && item.name}
              onChange={item => {
                form.setFieldValue(
                  'deliverableType',
                  item && item.deliverableTypeId,
                  false
                )
                form.setFieldTouched('deliverableType', true)
                form.setFieldValue('deliverableId', item && item.id, false)
                form.setFieldTouched('deliverableId', true)
              }}
              disabled={!isBackdatingRuleSatisfied(form)}
              component={Dropdown}
            />
          )}
        </div>
      </div>
    )
  }
}

export default inject('staticData')(observer(DeliverableFormGroup))
